import { useQuery } from "@tanstack/react-query";
import { decamelizeFilters } from "PFApp/booking/parts/reports/top_actions_panel/export_wizard/export_wizard_content/export_fields_utils";
import { useReportType } from "PFApp/booking/parts/reports/top_actions_panel/export_wizard/export_wizard_content/use_report_type";
import { filtersKeys } from "PFCore/hooks/queries/bookings/booking_export/query_keys";
import { fetchExportFilters } from "PFCore/services/export_booking";
import { ExportFiltersResponse } from "PFCore/services/export_booking/export_booking.types";

export const useExportFilters = () => {
  const { reportType } = useReportType();
  return useQuery<ExportFiltersResponse>(filtersKeys.reportType(reportType), async () => {
    const { entries, ...rest } = await fetchExportFilters({ reportType });
    return { entries: decamelizeFilters(entries), ...rest };
  });
};
